<template>
    <div>
        <div class="info-box">
            <courseinfo ref="courseinfo" :intoType='intoType' :intoCourseId='this.$route.query.courseId'></courseinfo>
        </div>
        <div class="info-box">
            <div class="info-title">
                <h3>代课、调课信息</h3>
                <p></p>
            </div>
            <div class="info-main">
                <div class="input-box">
                    <p>调、代课：</p>
                    <div class="radio">
                        <a-radio-group v-model="info.changeType" @change="onChange" :disabled="type!='add' && type!='edit'">
                            <a-radio value='1'>
                                代课
                            </a-radio>
                            <a-radio value='2'>
                                调课
                            </a-radio>
                        </a-radio-group>
                    </div>
                </div>
                <div class="input-box input-box-center">
                    <p>原因：</p>
                    <a-textarea v-model="info.applyReason" class="input" :rows="2"  :disabled="type!='add' && type!='edit'"/>
                </div>
            </div>
            <div class="info-main" v-show="info.changeType == '2'">
                <div class="input-box input-box-center">
                    <p>与学生协商情况：</p>
                    <a-textarea v-model="info.studentConsult" class="input" :rows="2"  :disabled="type!='add' && type!='edit'"/>
                </div>
            </div>
            <div class="file-input-box">
                <p class="p">证明材料：</p>
                <a-upload-dragger
                    class="input"
                    name="file"
                    list-type="picture-card"
                    :multiple="true"
                    :action="$store.state.axiosUrl+'/api-f/files'"
                    :headers="headers"
                    @change="fileChange"
                    :file-list="fileList"
                >
                    <p class="ant-upload-drag-icon">
                        <a-icon type="inbox" />
                    </p>
                    <p class="ant-upload-text">点击或拖拽证明材料文件上传</p>
                    <p class="ant-upload-hint">支持单次或批量上传</p>
                </a-upload-dragger>
            </div>
            <div class="info-main" v-show="info.changeType == '1'">
                <div class="input-box" >
                    <p>教师姓名：</p>
                    <a-select
                        :disabled="type!='add' && type!='edit'"
                        class="input" 
                        allowClear
                        show-search
                        :filter-option="filterOption"
                        v-model="info.substituteTeacherId"
                        @change="teacherSelect"
                        option-label-prop="label">
                        <a-select-option v-for="(item,index) in jsArr" :key="index" :value="item.teacherId" :label="item.teacherName">{{item.teacherId}}-{{item.teacherName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>职称：</p>
                    <a-input class="input" v-model="info.substituteTeacherZc" disabled/>
                </div>
                <div class="input-box">
                    <p>学位：</p>
                    <a-input class="input" v-model="info.substituteTeacherXw" disabled/>
                </div>
                <div class="input-box">
                    <p>所在院系：</p>
                    <a-input class="input" v-model="info.substituteTeacherYx" disabled/>
                </div>
            </div>
            <div class="info-main" >
                <div :class="classType">
                    <a-button class="editable-add-btn" @click="handleAdd"  :disabled="type!='add' && type!='edit'">
                    新增
                    </a-button>
                    <a-table bordered :data-source="dataSource" :columns="columns" :pagination="{hideOnSinglePage:true}">
                        <template slot="date1" slot-scope="text, record">
                            <!-- <editable-cell :text="text" @change="onCellChange(record.sortId, 'date1', $event)" /> -->
                            <a-date-picker :value='text' placeholder="请选择日期" @change="onCellChange(record.sortId, 'date1', $event)" />
                        </template>
                        <template slot="lessonNum1" slot-scope="text, record">
                            <a-input :disabled="type!='add' && type!='edit'" style="text-align:center" placeholder="0" addon-before="第" addon-after="节" :value="text" @change="e => onCellChange( record.sortId,'lessonNum1', e.target.value)"/>
                        </template>
                        <template slot="classRoom1" slot-scope="text, record">
                            <a-input :disabled="type!='add' && type!='edit'"  style="text-align:center" placeholder="0"  addon-after="教室" :value="text" @change="e => onCellChange( record.sortId,'classRoom1', e.target.value)"/>
                        </template>
                        <template slot="date2" slot-scope="text, record">
                            <a-date-picker :value='text' placeholder="请选择日期" @change="onCellChange(record.sortId, 'date2', $event)" />
                            <!-- <editable-cell :text="text" @change="onCellChange(record.sortId, 'date2', $event)" /> -->
                        </template>
                        <template slot="lessonNum2" slot-scope="text, record">
                            <a-input :disabled="type!='add' && type!='edit'"  style="text-align:center" placeholder="0" addon-before="第" addon-after="节" :value="text" @change="e => onCellChange( record.sortId,'lessonNum2', e.target.value)"/>
                        </template>
                        <template slot="classRoom2" slot-scope="text, record">
                            <a-input :disabled="type!='add' && type!='edit'"  style="text-align:center" placeholder="0"  addon-after="教室" :value="text" @change="e => onCellChange( record.sortId,'classRoom2', e.target.value)"/>
                        </template>
                        <template slot="operation" slot-scope="text, record">
                            <a-popconfirm
                            
                            v-if="dataSource.length"
                            title="确认删除?"
                            @confirm="() => onDelete(record.sortId)"
                            >
                            <a href="javascript:;" :disabled="type!='add' && type!='edit'">删除</a>
                            </a-popconfirm>
                        </template>
                    </a-table>
                </div>
            </div>
        </div>
        <div class="info-box" v-if="permissions.indexOf('undergraduate:culture:exchange:approve')>-1 && type!='add'">
            <div class="info-title">
                <h3>系意见</h3>
                <p></p>
            </div>
            <div class="info-main">      
                <div class="input-box input-box-center">
                    <p>意见：</p>
                    <a-textarea class="input" v-model="info.departmentOpinion" :rows="4"  :disabled="type!='approve'"/>
                </div>
            </div>
        </div>
        <div class="btn-box" v-if="type !='approve'">
            <a-button type="primary" v-if="type!='look'" @click="sub">提交</a-button>
            <a-button @click="$router.go(-1)">取消</a-button>
        </div>
        <div class="btn-box" v-if="type=='approve'">
            <a-button type="primary"  @click="approveClick('approved')">同意</a-button>
            <a-button type="primary"  @click="approveClick('reject')">驳回</a-button>
            <a-button @click="$router.go(-1)">取消</a-button>
        </div>
    </div>
</template>
<script>
    import { add,update,info,approve } from '@/baseAPI/undergraduate/culture/exchange'
    import { info as course } from '@/baseAPI/undergraduate/culture/course'
    import { getTeacher } from '@/baseAPI/facultyTeacher'
    import courseinfo from './courseInfo'

    const EditableCell = {
        template: `
            <div class="editable-cell">
                <div v-if="editable" class="editable-cell-input-wrapper">
                    <a-date-picker class="input" @change="handleChange" @pressEnter="check" />
                    <a-icon
                        type="check"
                        class="editable-cell-icon-check"
                        @click="check"
                    />
                </div>
                <div v-else class="editable-cell-text-wrapper">
                {{value||''}}
                <a-icon type="edit" class="editable-cell-icon" @click="edit" />
                </div>
            </div>
            `,
        props: {
            text: String,
        },
        data() {
            return {
                value: this.text,
                editable: false,
            };
        },
        methods: {
            handleChange(date, dateString) {
                this.value = dateString;
            },
            check() {
                this.editable = false;
                this.$emit('change', this.value);
            },
            edit() {
                this.editable = true;
            },
        },
    };

    export default {
        name: '',
        components: {
            courseinfo,
            EditableCell,
        },
        data () {
            return {
                file:[],
                fileList:[],
                headers:{
                    'Authorization':'Bearer '+ this.$store.state.access_token
                },
                permissions:[],
                classType:'tdk',
                type:'',
                jsArr:[],
                info:{
                    courseInfoId:"",
                    courseName:"",
                    teacherId:this.$store.state.user.userId,
                    teacherName:this.$store.state.user.name,
                    applyDate:this.formatDate(new Date()),
                    applyReason:"",
                    changeType:"1",
                    substituteTeacherId:"",
                    substituteTeacherName:"",
                    substituteTeacherZc:"",
                    substituteTeacherXw:"",
                    substituteTeacherYx:"",
                    studentConsult:"",
                    approvalStatus:"commit",
                    timeList:[]
                },
                intoType:'into',
                intoCourseId:'',
                source:'',
                dataSource: [
                    {
                        sortId: '0',
                        date1: null,
                        week1: null,
                        lessonNum1:null,
                        classRoom1:null,
                        date2: null,
                        week2: null,
                        lessonNum2: null,
                        classRoom2: null,
                        operate:'调至'
                    }
                ],
                count: 1,
                columns: [],
                dkColumns:[
                    {
                        title: '日期',
                        dataIndex: 'date1',
                        width: '10%',
                        align:'center',
                        colSpan: 2,
                        scopedSlots: { customRender: 'date1' }
                    },
                    {
                        title: '',
                        dataIndex: 'week1',
                        width: '5%',
                        align:'center',
                        colSpan: 0
                    },
                    {
                        title: '课时',
                        align:'center',
                        dataIndex: 'lessonNum1',
                        width: '5%',
                        scopedSlots: { customRender: 'lessonNum1' }
                    },
                    {
                        title: '操作',
                        dataIndex: 'operation',
                        width: '5%',
                        align:'center',
                        scopedSlots: { customRender: 'operation' },
                    },
                ],
                tkColumns:[
                    {
                        title: '日期',
                        dataIndex: 'date1',
                        width: '10%',
                        align:'center',
                        colSpan: 2,
                        scopedSlots: { customRender: 'date1' }
                
                    },
                    {
                        title: '',
                        dataIndex: 'week1',
                        width: '5%',
                        align:'center',
                        colSpan: 0
                    },
                    {
                        title: '课时',
                        align:'center',
                        dataIndex: 'lessonNum1',
                        width: '5%',
                        scopedSlots: { customRender: 'lessonNum1' }
                    },
                    {
                        title: '教室',
                        align:'center',
                        dataIndex: 'classRoom1',
                        width: '7%',
                        scopedSlots: { customRender: 'classRoom1' }
                    },
                    {
                        title: '',
                        align:'center',
                        dataIndex: 'operate',
                        width: '5%'
                    }
                    ,
                    {
                        title: '日期',
                        dataIndex: 'date2',
                        width: '10%',
                        align:'center',
                        colSpan: 2,
                        scopedSlots: { customRender: 'date2' }
                
                    },
                    {
                        title: '',
                        dataIndex: 'week2',
                        width: '7%',
                        align:'center',
                        colSpan: 0
                    },
                    {
                        title: '课时',
                        align:'center',
                        dataIndex: 'lessonNum2',
                        width: '5%',
                        scopedSlots: { customRender: 'lessonNum2' }
                    },
                    {
                        title: '教室',
                        align:'center',
                        dataIndex: 'classRoom2',
                        width: '7%',
                        scopedSlots: { customRender: 'classRoom2' }
                    },
                    {
                        title: '操作',
                        dataIndex: 'operation',
                        width: '5%',
                        align:'center',
                        scopedSlots: { customRender: 'operation' },
                    },
                ]
                ,
                weeks: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
                dayOfWeek:'',
            }
        },
        mounted () {
            this.permissions=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;
            this.columns=this.dkColumns
            this.classType='dk'
            this.type=this.$route.query.type;
            this.source=this.$route.query.source;
            this.info.courseInfoId=this.$route.query.courseId;
            if(this.type=='add'){
                // info(this.$route.query.tdkId).then(res=>{
                //     this.info=res.data
                // })
            }else{
                setTimeout(()=>{
                    info(this.$route.query.tdkId).then(res=>{
                        this.info=res.data;
                        this.info.changeType=res.data.changeType.toString()
                        this.dataSource=res.data.timeList
                        console.log(this.dataSource)
                        this.dataSource.forEach(time => {
                            time.operate='调至'
                        });
                        if(this.info.changeType=='1'){
                            this.columns=this.dkColumns
                            this.classType='dk'
                        }else{
                            this.columns=this.tkColumns
                            this.classType='tk'
                        }

                        this.fileList=[];
                        if(res.data.files!=''&&res.data.files!=null){
                            this.file=res.data.files.split(";");
                            for(let i=0;i<this.file.length;i++){
                                this.fileList.push({
                                    uid: i,
                                    name: this.file[i]+i,
                                    status: 'done',
                                    url: this.$store.state.axiosUrl+this.file[i],
                                })
                            }
                        }

                    })
                },500)
            }
            getTeacher().then(res=>{
                this.jsArr=res.data;
            })
            course(this.$route.query.courseId).then(res=>{
                this.info.courseName = res.data.courseName
            })

        },
        beforeCreate() {
            this.form = this.$form.createForm(this, { name: 'dynamic_form_item' });
            this.form.getFieldDecorator('keys', { initialValue: [], preserve: true });
        },
        methods:{
            fileChange(file){
                if(typeof file.file.response!='undefined'){
                    var res=file.file.response;
                    this.$notification['success']({
                        message: '成功',
                        description:'文件上传成功'
                    });
                    this.file.push(res.url)
                }else if(file.file.status=='removed'){
                    var num=this.file.indexOf(file.file);
                    this.file.splice(num, 1)
                }
                this.fileList=file.fileList;
                console.log('file:'+this.file)
            },
            formatDate (date) {
                let myyear = date.getFullYear();
                let mymonth = date.getMonth() + 1;
                let myweekday = date.getDate();
                let myHour = date.getHours();
                let myMin = date.getMinutes();
                let mySec = date.getSeconds();

                if (mymonth < 10) {
                    mymonth = '0' + mymonth;
                }
                if (myweekday < 10) {
                    myweekday = '0' + myweekday;
                }
                if (myHour < 10) {
                    myHour = '0' + myHour;
                }
                if (myMin < 10) {
                    myMin = '0' + myMin;
                }
                if (mySec < 10) {
                    mySec = '0' + mySec;
                }
                return (myyear + '-' + mymonth + '-' + myweekday + ' ' + myHour + ':' + myMin + ':' + mySec);
            },
            teacherSelect(){
                for(let i=0;i<this.jsArr.length;i++){
                    if(this.jsArr[i].teacherId==this.info.substituteTeacherId){
                        this.info.substituteTeacherId=this.jsArr[i].teacherId
                        this.info.substituteTeacherName=this.jsArr[i].teacherName
                        this.info.substituteTeacherZc=this.jsArr[i].technicalTitleName
                        this.info.substituteTeacherXw=this.jsArr[i].highestEducationName
                        this.info.substituteTeacherYx=this.jsArr[i].orgName
                    }
                }
            },
            onCellChange(key, dataIndex, value) {
                if(typeof value === 'object'){
                    value = value.format('YYYY-MM-DD HH:mm:ss')
                }
                const dataSource = [...this.dataSource];
                const target = dataSource.find(item => item.sortId === key);
                if (target) {
                    target[dataIndex] = value;
                    this.dataSource = dataSource;
                }
                
                this.dayOfWeek = this.weeks[new Date(value).getDay()]
                if(dataIndex=='date1'){
                    target['week1']=this.dayOfWeek
                }else if(dataIndex=='date2'){
                    target['week2']=this.dayOfWeek
                }
                
            },
            onDelete(key) {
                const dataSource = [...this.dataSource];
            
                this.dataSource = dataSource.filter(item => item.sortId !== key);
            },
            handleAdd() {
                const { count, dataSource } = this;
                const newData = {
                    sortId: count||'',
                    operate:'调至'
                };
                this.dataSource = [...dataSource, newData];
                this.count = count + 1;
            },
            onChange(e){
                this.info.changeType = e.target.value
                if(e.target.value == '2'){
                    this.columns=this.tkColumns
                    this.classType='tk'
                }else{
                    this.columns=this.dkColumns
                    this.classType='dk'
                }

            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            approveClick(state){
                var obj={
                    applyId:this.info.id,
                    code: state == 'approved' ? '1':'2',
                    approveStep:'1',
                    opinion:this.info.departmentOpinion,
                    chairman:this.$store.state.user.userId,
                    approveDate:this.formatDate(new Date())
                }
                approve(obj).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'调代课'+(state=='approved'?'审批通过':'驳回成功'),
                        });
                        this.$router.go(-1)
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })

            },
            sub(){
                var isSub=true;
                this.info.timeList=this.dataSource
                var arr;
                
                if(this.info.changeType == '1'){
                    arr = ['courseInfoId','timeList','substituteTeacherId','applyReason']
                }else{
                    arr = ['courseInfoId','timeList','studentConsult']
                }
                for(let i=0;i<arr.length;i++){
                    if(this.info[arr[i]]==null||this.info[arr[i]]===''){
                        isSub=false;
                        break;
                    }
                }
                if(isSub){
                    if(this.file.length > 0){
                        this.info.files=this.file.join(';')
                    }
                    if(this.type=='add'){
                        add(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'新增调代课成功，请联系系主任审批！',
                                    duration: 0,

                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else if(this.type=='approve'){
                        this.info.approvalStatus = 'commit'
                        approve(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'审核调代课成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else{
                        this.info.createTime = null;
                        update(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'修改调代课成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }
                }else{
                    this.$notification['warning']({
                        message: '警告',
                        description:'请填写完整！',
                    });
                }
            }
        }
    }
</script>
<style scoped>
    .info-box{
        margin-bottom: 2rem;
    }
    .info-title{
        position: relative;
        line-height: 3rem;
    }
    .info-title h3{
        font-size: 1.2rem;
        font-weight: bold;
        letter-spacing: 2px;
        padding-left: 10px;
        color: #245086;
    }
    .info-title p{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 50%;
        height: 3px;
        background-image: linear-gradient(to right, #245086 , rgba(36,80,134,0));
    }
    .info-title .ant-btn{
        float: right;
        margin-top: calc(1.5rem - 16px);
        margin-right: 2rem;
    }
    .info-main{
        display: flex;
        flex-wrap: wrap;
        margin-top: 1.5rem;
    }
    .info-main .input-box{
        width: 33%;
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }

    .file-input-box{
        width: 66%;
        line-height: 32px;
        margin-bottom: 1.5rem;
        display: flex;
        position: relative;
    }

    .file-input-box .p{
        width: 10rem;
        text-align: right;
    }

    .file-input-box .input{
        width: 50%;
        height: 100%;
        text-align: center;
    }
    
    .info-main .input-box-center{
        width: 66%;
    }

    .info-main .dk{
        width: calc(66% - 10rem);
        margin-left: 10rem;
    }

    .info-main .tk{
        width: calc(99% - 10rem);
        margin-left: 10rem;
    }


    .info-main .input-box p{
        width: 10rem;
        text-align: right;
    }
    .info-main .input-box .input{
        width: calc(100% - 10rem);
    }

    .info-main .input-box .radio{
        width: calc(100% - 10rem);
    }
    .info-main .input-box .tips{
        width: calc(100% - 11rem);
        position: absolute;
        right: 0;
        top: 100%;
        font-size: 13px;
        line-height: 20px;
        color: #1890ff;
    }
    .ant-table-wrapper{
        margin-top: 2rem;
    }
    .ant-table-wrapper >>> .ant-empty-normal{
        display: none;
    }
    .text-box{
        display: flex;
        margin-bottom: 0.5rem;
    }
    .text-box p{
        font-size: 1rem;
        line-height: 2rem;
    }
    .text-box .title{
        width: 5rem;
        text-align: right;
    }
    .text-box .text{
        border: 1px solid #ccc;
        padding: 0 10px;
        border-radius: 5px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 10px;
    }
    .ant-table-wrapper .input-box{
        width: 100%;
    }
    .btn-box{
        text-align: center;
    }
    .btn-box .ant-btn{
        margin: 0 1rem;
    }
    .input >>> .ant-input[disabled],
    .ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }
    .standard{
        width: 28px;
        height: 100px;
        position: absolute;
        right: 0;
        top: 200px;
        text-align: center;
        border-radius: 6px 0 0 6px !important;
        z-index: 0;
        pointer-events: auto;
        cursor: pointer;
        color: rgb(255, 255, 255);
        background-color: #245086;
        opacity: 0.8;
        padding: 2px 0px 0px 0px;
    }

    .standard:hover{
        opacity: 1;
    }

    .info-main .input-maxbox{
        width: 99%;
        display: flex;
        line-height: 32px;
        position: relative;
    }

    .info-main .input-maxbox p{
        width: 10rem;
        text-align: right;
    }

    .info-main .input-maxbox .textarea{
        width: calc(100% - 10rem);
    }

    .info-main .input-notes{
        width: 99%;
        display: flex;
        line-height: 32px;
        position: relative;
    }

    .info-main .input-notes .notes{
        width: calc(100% - 10rem);
        text-align: left;
        font-size: 0.9rem;
    }

    .info-main .input-notes .note-title{
        width: 10rem;
        text-align: right;
        font-size: 0.9rem;
        font-weight: bolder;
        color: black;
    }

    .editable-cell {
        position: relative;
    }

    .editable-cell-input-wrapper,
        .editable-cell-text-wrapper {
        padding-right: 24px;
    }

    .editable-cell-text-wrapper {
        padding: 5px 24px 5px 5px;
    }

    .editable-cell-icon,
        .editable-cell-icon-check {
        position: absolute;
        right: 0;
        width: 20px;
        cursor: pointer;
    }

    .editable-cell-icon {
        line-height: 18px;
        display: none;
    }

    .editable-cell-icon-check {
        line-height: 28px;
    }

    .editable-cell:hover .editable-cell-icon {
        display: inline-block;
    }

    .editable-cell-icon:hover,
    .editable-cell-icon-check:hover {
        color: #108ee9;
    }

    .upload-box{
        width: 100%;
        height: 100%;
    }

    .upload-box >>> .ant-upload-list:after{
      content: ".";
      display: block;
      font-size: 0;
      height: 0;
      clear: both;
    }
    .upload-box >>> .ant-upload.ant-upload-disabled{
        display: none;
    }

    /* .editable-add-btn {
        margin-bottom: 2px;
    } */


</style>
